module.exports = __webpack_public_path__ + "static/media/user6-simon-brookes.f7bf5892.jpg";